import React from "react";

const DIM = 21;

const hashSeed = (value) => {
  let seed = 0;
  for (let i = 0; i < value.length; i++) seed = (seed * 31 + value.charCodeAt(i)) >>> 0;
  return seed;
};

const makeRng = (initialSeed) => {
  let seed = initialSeed;
  return () => {
    seed = (seed * 1103515245 + 12345) & 0x7fffffff;
    return seed / 0x7fffffff;
  };
};

const isFinderRegion = (r, c) => {
  const inBox = (br, bc) => r >= br && r < br + 7 && c >= bc && c < bc + 7;
  return inBox(0, 0) || inBox(0, DIM - 7) || inBox(DIM - 7, 0);
};

const finderCell = (r, c) => {
  const ring = (br, bc) => {
    const rr = r - br;
    const cc = c - bc;
    if (rr === 0 || rr === 6 || cc === 0 || cc === 6) return true;
    return rr >= 2 && rr <= 4 && cc >= 2 && cc <= 4;
  };
  if (r < 7 && c < 7) return ring(0, 0);
  if (r < 7 && c >= DIM - 7) return ring(0, DIM - 7);
  if (r >= DIM - 7 && c < 7) return ring(DIM - 7, 0);
  return false;
};

const buildCells = (value) => {
  const rng = makeRng(hashSeed(value));
  const cells = [];
  for (let r = 0; r < DIM; r++) {
    for (let c = 0; c < DIM; c++) {
      const fill = isFinderRegion(r, c) ? finderCell(r, c) : rng() > 0.5;
      cells.push({ r, c, fill });
    }
  }
  return cells;
};

// Deterministic pseudo-QR generator (visual only, for demo confirmation).
export const QRCode = ({ value = "SLOT", size = 168 }) => {
  const cells = buildCells(value);
  const unit = size / DIM;
  return (
    <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`} data-testid="qr-code"
         style={{ background: "#fff", borderRadius: 10, padding: unit }}>
      {cells.map(({ r, c, fill }) =>
        fill ? (
          <rect key={`${r}-${c}`} x={c * unit} y={r * unit} width={unit} height={unit} fill="#0a0a0a" />
        ) : null
      )}
    </svg>
  );
};

export default QRCode;
